
export class RequiredDocumentDetailsModel {
    public documentTypeId = 0;
    public documentCategoryTypeId = 0;
    public documentTypeDisplayValue = '';
    public documentCategoryTypeDisplayValue = '';
    public documentRequirementTypeId = 0;
    public requirementSatisfied = false;
}
